module.exports = __webpack_public_path__ + "img/Montazhi_EAD_logo.44ac8dba.svg";